import { startOfWeek } from "date-fns";
import { parseScheduleDate } from "campaign-builder/state/h2hSchedule";
import type { TargetingArea } from "../../targeting";

type Channel = "H2H" | "D2D";

// Campaign duration in weeks, mirroring the legacy calculation the submit
// payload needs (campaignDurationWeek). H2H = the number of distinct calendar
// weeks any distribution is scheduled in; D2D = the selected areas spread over
// the per-week limit. Always at least one week.
export const resolveCampaignDuration = (
  channel: Channel,
  areas: TargetingArea[],
  weeklyMissionLimit: number
): number => {
  if (channel === "D2D") {
    return weeklyMissionLimit ? Math.max(1, Math.ceil(areas.length / weeklyMissionLimit)) : 1;
  }

  const weeks = new Set<string>();
  areas.forEach((area) =>
    (area.schedule ?? []).forEach((entry) => {
      if (!entry.times.length) return;
      const day = parseScheduleDate(entry.date);
      if (!day) return; // skip rows with an unparseable date
      const weekStart = startOfWeek(day, { weekStartsOn: 1 });
      weeks.add(weekStart.toISOString().slice(0, 10));
    })
  );
  return Math.max(1, weeks.size);
};
